import { ThemeButton } from '@shared/ui/buttons';
import { DialogContent, DialogActions } from '@mui/material';
import Note from '@shared/ui/messages/Note';
import { icons } from '@shared/static/icons';
import { ListData, CounterTag } from '@shared/ui/parts';
import { getCryptoName } from '@utils/balance-helpers';
import {
  useRequestTwofaDialog,
  useDeleteChannelDialog,
} from '@utils/dialogs-hooks';
import { useChannel } from '@app/api/profile/useChannel';

export default function DeleteChannelDialog({ close, data }) {
  const { openRequestTwofaDialog } = useRequestTwofaDialog();
  const { deleteChannel } = useChannel();
  const { openDeleteChannelDialog } = useDeleteChannelDialog();

  function handleDelete() {
    openRequestTwofaDialog(
      { id: data.id },
      (err) => openDeleteChannelDialog(data, err),
      deleteChannel,
    );
  }

  return (
    <>
      <DialogContent>
        <CounterTag data={data} />
        <br />
        <ListData
          listData={[
            {
              label: 'Channel',
              value: data.currency,
            },
            {
              label: 'Wallet address',
              value: data.address,
              isCopy: true,
            },
            // {
            //   label: 'Address',
            //   value: 'Jasmiini tee 94, 11912 Tallinn, Estonia',
            // },
            // {
            //   label: 'IBAN / AN',
            //   value: '845454864561216548845454864561216548',
            //   isCopy: true,
            // },
            // {
            //   label: 'Name',
            //   value: 'Sigourney Weaver',
            // },
          ]}
        />
        <Note
          singleLine
          marginTop
          type="warning"
          content="This channel won't be available for withdrawals until you add it again."
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton onClick={handleDelete} startIcon="delete">
            Delete
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            Cancel
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}

function Logo() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2324_32546)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="#26A17B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.922 17.3824V17.3804C17.812 17.3884 17.245 17.4224 15.98 17.4224C14.97 17.4224 14.259 17.3924 14.009 17.3804V17.3834C10.121 17.2124 7.219 16.5354 7.219 15.7254C7.219 14.9154 10.121 14.2394 14.009 14.0654V16.7094C14.263 16.7274 14.991 16.7704 15.997 16.7704C17.204 16.7704 17.809 16.7204 17.922 16.7104V14.0674C21.802 14.2404 24.697 14.9174 24.697 15.7254C24.697 16.5354 21.802 17.2104 17.922 17.3824ZM17.922 13.7924V11.4264H23.336V7.81836H8.595V11.4264H14.009V13.7914C9.609 13.9934 6.3 14.8654 6.3 15.9094C6.3 16.9534 9.609 17.8244 14.009 18.0274V25.6094H17.922V18.0254C22.315 17.8234 25.616 16.9524 25.616 15.9094C25.616 14.8664 22.315 13.9954 17.922 13.7924Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2324_32546">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
